var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('config-card', { ref: "form", staticClass: "demand-info-product", attrs: { "title": "产品链接信息", "form-loading": _vm.formLoading, "form-config": _vm.formConfig, "form-value": _vm.formValue, "form-item-list": _vm.formItemList }, on: { "mounted": _vm.getAppInfoByUrl } });
};
var staticRenderFns = [];

export { render, staticRenderFns };